import { FC } from "react";

import { Trans, useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import {
  FormCampaignTargetThermometer,
  FormCampaignTargetThermometerProps,
} from "@/forms-design-system/FormCampaignTargetThermometer";
import { FormTypography } from "@/forms-design-system/FormTypography";

export type CampaignTargetThermometerProps = Omit<FormCampaignTargetThermometerProps, "label">;

export const CampaignTargetThermometer: FC<CampaignTargetThermometerProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return (
    <FormCampaignTargetThermometer
      id={FORM_ELEMENT_IDS["fundraising-goal"]}
      label={{
        renderCurrentAmount: (currentCollectedAmount: string, targetedAmount: string) => (
          <Trans
            space="ticketing"
            i18nKey="thermometer"
            values={{ value: currentCollectedAmount, goal: targetedAmount }}
            components={{ amount: <FormTypography variant="h6" component="span" /> }}
          />
        ),
        ongoingCampaign0To49: t("ticketing", "thermometer.promote.1"),
        ongoingCampaign50To79: t("ticketing", "thermometer.promote.2"),
        ongoingCampaign80To99: t("ticketing", "thermometer.promote.3"),
        campaignAchieved: t("ticketing", "thermometer.promote.4"),
        encouragement: {
          incredible: t("ticketing", "thermometer.encouragement.incredible"),
          inspiring: t("ticketing", "thermometer.encouragement.inspiring"),
          almostThere: t("ticketing", "thermometer.encouragement.almostThere"),
          beautifulStart: t("ticketing", "thermometer.encouragement.beautifulStart"),
          meansSoMuch: t("ticketing", "thermometer.encouragement.meansSoMuch"),
        },
      }}
      {...rest}
    />
  );
};
